import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import Routes from "Configs/routes";
import { getPhoneNumberByCode } from "Utils/siteConfig";
import { pipe } from "Utils/functionalUtils";
import PlanCRowContainer from "Containers/PlanCRowContainer";
import { TarifficationCWrapper } from "ComponentsUI/TarifficationC";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";

const TariffsWithTags = (props) => {
	const {
		ApplicationModel: {
			siteCode,
			text,
			windowSizeModel: { windowSizes },
		},
		tariffs,
	} = props;
	let connectTariffButton =
		props.ApplicationModel?.siteConfig?.settings?.connect_tariff_button?.[props.pageName] ||
		"connect";

	let generateProviderRates = (data) => {
		if (data) {
			props.providerModel.changeTab("provider_tab_tariffs");
			let providerUrl = generateUrl(Routes.ProviderRates.route, {
				providerName: data.provider.url_name,
				regionUrl: data.region.url,
			});
			return providerUrl;
		}
		return "/";
	};

	let displayText = () => {
		const phoneNumber = getPhoneNumberByCode(siteCode);

		return (
			<div>
				{text.NO_TARIFFS_WITH_FILTER}
				<span style={{ whiteSpace: "nowrap" }}>{phoneNumber}</span> {text.NO_TARIFFS_WITH_FILTER_2}
			</div>
		);
	};

	const toHomeURL = generateUrl(Routes.Default.route, {
		regionUrl: props.match.params.regionUrl,
	});

	useEffect(() => {
		if (
			windowSizes.height &&
			connectTariffButton === "connect" &&
			!!tariffs.length &&
			tariffs.find((tariff) => tariff?.provider?.vip_provider == 1) &&
			tariffs.find(
				(tariff) => tariff?.provider?.provider_settings?.tariffs?.value === "button_text"
			)
		) {
			sendMetriks("OPEN_NEW_TEXT");
		}
	}, [tariffs, windowSizes.height]);

	if (!!tariffs.length) {
		return (
			<TarifficationCWrapper text={text} presenceBrand={props.presenceBrand} tariffs={tariffs}>
				{tariffs.map((tariff) => {
					return (
						<PlanCRowContainer
							key={tariff.id}
							tariff={tariff}
							generateProviderRates={(tariff) => generateProviderRates(tariff)}
							pageName={props.pageName}
							isRatesTag={props.isRatesTag}
							isProviderRatesTag={props.isProviderRatesTag}
							isRegionRatesTag={props.isRegionRatesTag}
						/>
					);
				})}
			</TarifficationCWrapper>
		);
	} else {
		return (
			<EmptyStubWrapper
				link={toHomeURL}
				header={text.NO_TARIFFS_HEADER}
				headerText={text.NO_TARIFFS_HEADER}
				displayText={displayText()}
				buttonText={text.TO_MAIN_PAGE}
				iconHeader={"icon-balance"}
			/>
		);
	}
};

export default pipe(observer, inject("ApplicationModel"), withRouter)(TariffsWithTags);
